var variantRes = [], $ = jQuery;
jQuery(document).ready(function() {
	jQuery(document).on('click','a.product-watch__item-link', function(e) {
		e.preventDefault();
		var selectedSize = $('.product-single__size-wrapper .product-size__item.active').attr('data-target');
		if ($(this).parent().hasClass('current-watch')) {
			$('.product-single').removeClass('loading');
			return false;
		}
		var thisCurrency = jQuery('.product-single__swatch-wrapper').attr('data-currency');
		var thisProdId = $(this).attr('data-prodid');
		var thisProdCat = $(this).attr('data-prodcat');
		var thisProdTitle = $(this).attr('data-prodtitle');
		var thisProdPrice = parseInt($(this).attr('data-prodprice') / 100).toFixed(2).replace(/(\d)(?=(\d\d\d)+(?!\d))/g, "$1,");
		var thisAPProdPrice = parseInt($(this).attr('data-prodprice'));
    var prodUrl = jQuery(this).attr('href');
		if (variantRes[prodUrl] != undefined) {
			var productCol = variantRes[prodUrl].prodrow;
			var tabtitle = variantRes[prodUrl].tabtitle;
			var upsellContent = variantRes[prodUrl].upsell;
			$('head title').text(tabtitle);
			//var featuredProd = variantRes[prodUrl].featprodrow;
			$('.upsell-popup-wrapper').remove();
			upsellContent.insertBefore('.upsell-popup-overlay');
			productCol.find('.product-single__size-wrapper .product-size__item.active').removeClass('active');
			$('#shopify-section-product-template').html(productCol.unwrap());
			$('.product-single__size-wrapper .product-size__item[data-target="'+selectedSize+'"]').trigger('click');
			$('.product-mobile-size-selector select').val(selectedSize).trigger('change');
			$('.sticky-addtocart-wrapper .selector-wrapper-size-7 select, .sticky-addtocart-wrapper .selector-wrapper-size-3 select, .sticky-addtocart-wrapper .selector-wrapper-size-4 select, .sticky-addtocart-wrapper .selector-wrapper-size-5 select, .sticky-addtocart-wrapper .selector-wrapper-size-6 select, .sticky-addtocart-wrapper .selector-wrapper-size-8 select, .sticky-addtocart-wrapper .selector-wrapper-size-9 select').val(selectedSize);
			if ($('.product-single__photos-slider').hasClass('slick-initialized') ) {
				jQuery('.product-single__photos-slider').slick('refresh').removeClass('loading');
			} else {
				productImageSlider();
			}
			//jQuery('#shopify-section-featured-collection-sheet-set').html(featuredProd.unwrap());
			updateAvailbility();
			BISemailNotif();
			jQuery('.product-size__item.active').trigger('click');
			// jQuery('body').trigger('variantChange');
			fbq('track', 'ViewContent', {
				content_ids: [parseInt(thisProdId)],
				content_type: 'product_group',
				content_name: thisProdTitle,
				content_category: thisProdCat,
				currency: thisCurrency,
				value: thisProdPrice
			});
			if (jQuery('#AddToCart-product-template').length > 0) {
				jQuery('#AddToCart-product-template').addClass('ajax-addtc');
			}
			$('.product-single').removeClass('loading');
			$('.page-loader').addClass('loaded').removeClass('loading');
			googleEventPush();
        // Reinit afterpay code and duplicate widget
        clearDuplicates();
        apConfig.amount = thisAPProdPrice;
        new presentAfterpay(apConfig).init();
        duplicateAPWidget();
        modalOverride();
		} else {
			$('.product-single').addClass('loading');
			$('.page-loader').addClass('enabled loading').removeClass('loaded');
			jQuery.ajax({
				type: 'GET',
				url: prodUrl,
				async: true,
				beforeSend: function(data) {
				},
				success: function(data) {
					var productCol = jQuery(data).find('#shopify-section-product-template').eq(0);
					var tabtitle = jQuery(data).find('.tab-seo-title').text();
					var upsellContent = jQuery(data).find('.upsell-popup-wrapper').eq(0);
					$('head title').text(tabtitle);
					//var featuredProd = jQuery(data).find('#shopify-section-featured-collection-sheet-set').eq(0);
					$('.upsell-popup-wrapper').remove();
					upsellContent.insertBefore('.upsell-popup-overlay');
					productCol.find('.product-single__size-wrapper .product-size__item.active').removeClass('active');
					$('#shopify-section-product-template').html(productCol.unwrap());
					$('.product-single__size-wrapper .product-size__item[data-target="'+selectedSize+'"]').trigger('click');
					$('.product-mobile-size-selector select').val(selectedSize).trigger('change');
					$('.sticky-addtocart-wrapper .selector-wrapper-size-7 select, .sticky-addtocart-wrapper .selector-wrapper-size-3 select, .sticky-addtocart-wrapper .selector-wrapper-size-4 select, .sticky-addtocart-wrapper .selector-wrapper-size-5 select, .sticky-addtocart-wrapper .selector-wrapper-size-6 select, .sticky-addtocart-wrapper .selector-wrapper-size-8 select, .sticky-addtocart-wrapper .selector-wrapper-size-9 select').val(selectedSize);
					if ($('.product-single__photos-slider').hasClass('slick-initialized') ) {
						jQuery('.product-single__photos-slider').slick('refresh').removeClass('loading');
					} else {
						productImageSlider();
					}
					updateAvailbility();
					BISemailNotif();
					jQuery('.product-size__item.active').trigger('click');
					$('.product-single').removeClass('loading');
					$('.page-loader').addClass('loaded').removeClass('loading');
					// jQuery('body').trigger('variantChange');
					fbq('track', 'ViewContent', {
						content_ids: [parseInt(thisProdId)],
						content_type: 'product_group',
						content_name: thisProdTitle,
						content_category: thisProdCat,
						currency: thisCurrency,
						value: thisProdPrice
					});
					if (jQuery('#AddToCart-product-template').length > 0) {
						jQuery('#AddToCart-product-template').addClass('ajax-addtc');
					}
					//jQuery('#shopify-section-featured-collection-sheet-set').html(featuredProd.unwrap());
					googleEventPush();
				}
			});
		}
	});

	$(document).on('click', '.ajax-addtc', function(e) {
		e.preventDefault();
		var variantID = $('#ProductSelect-product-template').val();
		var prodQuantity = $('input[name="quantity"].product-form__input ').val();
		var preOrderProp = ($('#preorder-note').attr('value') != '') ? $('#preorder-note').attr('value') : '';
		var prodProperties = { 'PreOrder' : preOrderProp };
		if (preOrderProp != '') {
			var prodData = {
				quantity: prodQuantity,
				id: variantID,
				properties: prodProperties
			}
		} else {
			var prodData = {
				quantity: prodQuantity,
				id: variantID
			}
		}
		$.ajax({
			type: 'POST',
			url: '/cart/add.js',
			dataType: 'json',
			data: prodData,
			async: false,
			beforeSend: function() {
			},
			success: function(data) {
				// UPDATE TOTAL CART DRAWER
				updateCartDrawer();
				jQuery.getJSON('/cart.js', function(cart) {
					updateCartDrawer();
					var hasCandle = false;
					var declineFreecandle = getCookie('decline-freecandle');
					jQuery.each(cart.items, function(index, item) {
						if ( item.id == 11267489595439 || item.id == 11267489628207 ) {
							hasCandle = true;
						}
					});
					if ( enable_free_candles && cart.total_price >= 50000 && !hasCandle && declineFreecandle != 'true' ) {
						showFreeCandle();
					} else {
						//showCartDrawer();
						showUpsell();
					}
				});
				googleEventAddtoCartPush(prodQuantity);
			},
			error: function() {
			}
		});
	});
});

jQuery(window).on('load', function() {
	jQuery('a.product-watch__item-link').each(function() {
		var thisUrl = jQuery(this).attr('href');
		if (variantRes[thisUrl] == undefined) {
			jQuery.ajax({
				type: 'GET',
				url: thisUrl,
				async: true,
				beforeSend: function(data) {
				},
				success: function(data) {
					variantRes[thisUrl] = {
						'prodrow': jQuery(data).find('#shopify-section-product-template').eq(0),
						'tabtitle': jQuery(data).find('.tab-seo-title').text(),
						'upsell': jQuery(data).find('.upsell-popup-wrapper').eq(0)
						// 'featprodrow': jQuery(data).find('#shopify-section-featured-collection-sheet-set').eq(0)
					}
				}
			});
		}
	});
});

function googleEventPush() {
	var prodTitle = jQuery('.product-swatch__item.current-watch .product-watch__item-link').attr('data-prodtitle');
	var prodPrice = jQuery('.product-swatch__item.current-watch .product-watch__item-link').attr('data-prodprice');
	var prodCategory = jQuery('.product-swatch__item.current-watch .product-watch__item-link').attr('data-prodcat');
	var prodVendor = jQuery('.product-swatch__item.current-watch .product-watch__item-link').attr('data-prodvendor');
	var selectedId = jQuery('#ProductSelect-product-template').val();
	var variantName = jQuery('#ProductSelect-product-template option[value="'+selectedId+'"]').text();

	var itemColor = variantName.split(' / ');
	itemColor = itemColor[0].replace(/\s/g, '');
	var mainProdTitle = prodTitle.replace(itemColor + ' ', '');


	window.dataLayer.push({
		event: 'productDetailView',
		ecommerce: {
			currencyCode: window.ShopifyAnalytics.meta.currency,
			detail: {
				products: [{
					name: prodTitle,
					id: selectedId,
					price: prodPrice / 100,
					brand: prodVendor,
					variant: variantName,
					category: prodCategory,
				}]
			}
		}
	});

	window.dataLayer.push({
		event: 'uxTracking',
		siteComponent: 'colourSwatch',
		componentLabel: `${itemColor} - ${mainProdTitle}`
	});
}

function googleEventAddtoCartPush(prodQuantity) {
	var prodTitle = jQuery('.product-swatch__item.current-watch .product-watch__item-link').attr('data-prodtitle');
	var prodPrice = jQuery('.product-swatch__item.current-watch .product-watch__item-link').attr('data-prodprice');
	var prodCategory = jQuery('.product-swatch__item.current-watch .product-watch__item-link').attr('data-prodcat');
	var prodVendor = jQuery('.product-swatch__item.current-watch .product-watch__item-link').attr('data-prodvendor');
	var selectedId = jQuery('#ProductSelect-product-template').val();
	var variantName = jQuery('#ProductSelect-product-template option[value="'+selectedId+'"]').text();
	window.dataLayer.push({
		event: "addToCart",
		ecommerce: {
			currencyCode: ShopifyAnalytics.meta.currency,
			add: {
				products: [
					{
						name: prodTitle,
						id: selectedId,
						price: prodPrice / 100,
						brand: prodVendor,
						variant: variantName,
						quantity: prodQuantity,
						category: prodCategory
					}
				]
			}
		}
	});
}